import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { ProspectDetails_FieldsFragmentDoc } from './sales-portal-prospect-details-fragments.generated';
const defaultOptions = {} as const;

export const SalesPortalUpdateProspectDetailsDocument = gql`
  mutation SalesPortalUpdateProspectDetails(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $prospectDetails: ProspectDetailsUpdateInput!
  ) {
    updateSalesPortalProspectDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      prospect_details: $prospectDetails
    ) {
      ...ProspectDetails_Fields
    }
  }
  ${ProspectDetails_FieldsFragmentDoc}
`;
export type SalesPortalUpdateProspectDetailsMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalUpdateProspectDetailsMutation,
    Types.SalesPortalUpdateProspectDetailsMutationVariables
  >;
export function useSalesPortalUpdateProspectDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateProspectDetailsMutation,
    Types.SalesPortalUpdateProspectDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateProspectDetailsMutation,
    Types.SalesPortalUpdateProspectDetailsMutationVariables
  >(SalesPortalUpdateProspectDetailsDocument, options);
}
export type SalesPortalUpdateProspectDetailsMutationHookResult = ReturnType<
  typeof useSalesPortalUpdateProspectDetailsMutation
>;
export type SalesPortalUpdateProspectDetailsMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateProspectDetailsMutation>;
export type SalesPortalUpdateProspectDetailsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateProspectDetailsMutation,
    Types.SalesPortalUpdateProspectDetailsMutationVariables
  >;
